import BrokerMastertrustContainer from "./BrokerMastertrustContainer";

export default BrokerMastertrustContainer;